<template>
<div>
  <!-- Modal Content -->
  <transition name="modal">
    <div class="modal-backdrop" role="dialog">
      <div class="modal" ref="modal" aria-labelledby="modalTitle" aria-describedby="modalDescription" v-on-clickaway="away">
        <header class="modal-header" id="modalTitle">
          <slot name="header">
            {{modalHeading}}
            <button type="button" class="btn-close pull-right" @click="close" aria-label="Close modal"><i class="ti-close"></i></button>
          </slot>
        </header>
        <!-- <button type="button" @click="debug" aria-label="Debug">Debug</button> -->
        <!-- Skeleton Loader -->
        <div v-if="loading" class="skeleton-loader">
          <!-- Skeleton rows -->
          <div class="skeleton-row" v-for="n in 30" :key="n"></div>
        </div>
        <section v-if="!loading" class="modal-body">
          <slot name="body">
            <div align="center">
              <h4 style="margin: 10px 0 0;">{{store_info.NAME}}</h4>
              <p>{{store_info.ADDRESS1}}</br>
                {{store_info.CITY}}, {{store_info.STATE}} {{store_info.RZIP}}</p>
            </div>


            <table class="items-table">
              <tbody>
                <!-- Items -->
                <tr>
                  <td><b>Item</b></td>
                  <td width="60%"></td>
                  <td align="right"><b>Price</b></td>
                  <td align="right"><b>Total</b></td>
                </tr>
                <tr v-for="item in order_items">
                  <td width="25">{{item.QUANTITY}} x</td>
                  <td width="60%">{{item.ITEM}}</td>
                  <td align="right">{{item.ITEMTOTAL}}</td>
                  <td align="right">{{item.ITEMSUBTOTAL}}</td>
                </tr>
                <tr class="blank_row">
                  <td colspan="3"></td>
                </tr>
                <!-- Totals -->
                <tr>
                  <td></td>
                  <td width="60%"></td>
                  <td align="right"><b>Subtotal</b></td>
                  <td align="right">{{totals.ITEMSUBTOTAL}}</td>
                </tr>
                <tr>
                  <td></td>
                  <td width="60%"></td>
                  <td align="right"><b>Tax</b></td>
                  <td align="right">{{totals.ITEMTAX}}</td>
                </tr>
                <tr>
                  <td></td>
                  <td width="60%"></td>
                  <td align="right"><b>Order Total</b></td>
                  <td align="right">{{totals.TOTAL_AT}}</td>
                </tr>
              </tbody>
            </table>
          </slot>
        </section>
        <footer class="modal-footer">
          <slot name="footer">
            <button class="btn btn-primary btn-fill btn-wd" @click="close">{{modalButtonText}}</button>
          </slot>
        </footer>
      </div>
    </div>
  </transition>
</div>
</template>

<script>
import {API} from 'src/api'
import PortalNotification from 'src/components/UIComponents/NotificationPlugin/Notification.vue'
import { mixin as clickaway } from 'vue-clickaway'
var support = ''
var userRoles = ''
export default {
  data () {
    return {
      order_items: [],
      totals: [],
      store_info: [],
      modalHeading: 'Order Details',
      modalButtonText: 'Close',
      loading: true
    }
  },
  mixins: [ clickaway ],
  components: {
    PortalNotification
  },
  methods: {
    close () {
      this.$emit('close')
      this.loading = false
      this.order_items = []
      this.totals = []
      this.store_info = []
    },
    away: function() {
      this.close()
    },
    notifyVue (verticalAlign, horizontalAlign, message, icon, type) {
      this.$notifications.notify(
        {
          message: message,
          icon: icon,
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type: type
        })
    },
    debug() {
      console.log('order_items:', this.order_items);
      console.log('totals:', this.totals);
      console.log('store_info:', this.store_info);
      console.log('loading:', this.loading);
    }
  },
  computed: {
  },
  mounted () {
  },
}
</script>

<style>
  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3) !important;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: opacity .3s ease;
  }
  .modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: -ms-flexbox !important;
    display: flex !important;
    -ms-flex-direction: column;
    flex-direction: column;
    width: 700px;
    transition: opacity .3s ease;
    /* overflow: scroll !important; */
    margin: 0 auto;
    top: 30px !important;
    bottom: 50px !important;
    /* max-height: 500px; */
  }
  .modal-header,
  .modal-footer {
    padding: 0 15px;
  }
  .modal-header {
    border-bottom: 1px solid #eeeeee;
    text-align: center;
    font-weight: 600;
    color: #333;
    font-size: 22px;
  }
  .modal-footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    background: #fff;
  }
  .modal-body {
    max-height: calc(100vh - 150px - 60px);
    max-height: -moz-calc(100vh - 150px - 60px);
    max-height: -webkit-calc(100vh - 150px - 60px);
    width: 100%;
    overflow-y: auto !important;
  }
  .btn-close {
    border: none;
    font-size: 20px;
    font-weight: bold;
  }
  .border-danger {
    border-color: red !important;
  }
  /*
  * The following styles are auto-applied to elements with
  * transition="modal" when their visibility is toggled
  * by Vue.js.
  */

  .modal-enter-active,
  .modal-leave-active {
    transition: opacity .8s;
  }
  .modal-enter-to,
  .modal-leave {
    transform: translateX(50);
  }
  .modal-enter,
  .modal-leave-to,
  /* .modal-leave-active in <2.1.8 */ {
  opacity: 0;
  }
  .checkbox_label {
    font-size: 12px;
  }
  .modal .modal-footer .btn-wd {
    margin: 0;
  }
  /* white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; */
  .items-table {
    width: 100%;
    margin: 0 0 25px 0;
  }
  .blank_row {
    height: 30px !important;
  }
  #show-modal {
    cursor: pointer;
    /* color: #337ab7; */
  }
  .pull-right {
    float: right !important;
    position: absolute;
    right: 10px;
  }
  /* Skeleton loader animation */
  .skeleton-loader {
    position: relative;
    overflow: hidden;
  }

  .skeleton-row {
    width: 100%;
    height: 20px;
    margin-bottom: 10px; /* Adjust margin between rows */
    background: linear-gradient(to right, #f0f0f0 0%, #e0e0e0 50%, #d0d0d0 100%);
    background-size: 200% 100%; /* Double the width for smooth animation */
    animation: slideRight 2s infinite alternate; /* Animation duration and direction */
  }

  @keyframes slideRight {
    0% {
      background-position: 0 0; /* Start position */
    }
    100% {
      background-position: 100% 0; /* End position (to cover the entire width) */
    }
  }

</style>



// WEBPACK FOOTER //
// OrderModal.vue?4201cc49